import { DatePipe } from "@angular/common";
import {
  AfterViewInit,
  Component,
  computed,
  OnDestroy,
  OnInit,
} from "@angular/core";
import { Store } from "@ngrx/store";
import { TranslatePipe } from "@ngx-translate/core";
import { Instruction } from "src/app/models/instruction/instruction";
import { InstructionConfirmation } from "src/app/models/instruction/instruction-confirmation";
import { InstructionDetailsActions } from "src/app/ngrx/actions";
import { AppState } from "src/app/ngrx/reducers";
import { InstructionDetailsSelectors } from "src/app/ngrx/selectors";
import { LoadingIndicatorComponent } from "../../utils/loading-indicator/loading-indicator.component";
import { SubscriptionHelper } from "@aht/frappe-client";
import { ChaptersComponent } from "../chapters/chapters.component";
import { Chapter } from "src/app/models/instruction/chapter";
import { ChapterDetailsComponent } from "../chapter-details/chapter-details.component";
import {
  DeadlineService,
  DeadlineStatus,
} from "src/app/services/deadline.service";

@Component({
  selector: "app-instruction-detail",
  templateUrl: "./instruction-detail.component.html",
  styles: ``,
  imports: [
    DatePipe,
    TranslatePipe,
    LoadingIndicatorComponent,
    ChaptersComponent,
    ChapterDetailsComponent,
  ],
})
export class InstructionDetailComponent
  implements OnInit, OnDestroy, AfterViewInit
{
  private readonly helper = new SubscriptionHelper();

  isLoadingMyInstruction: boolean = false;
  myInstruction?: Instruction;

  // isConfirmingChapter: boolean = false;
  isLoadingMyInstructionConfirmation = false;
  myInstructionConfirmation?: InstructionConfirmation;
  // chapters = this.store.selectSignal(InstructionDetailsSelectors.chapters);

  deadlineStatus: DeadlineStatus = "none";

  constructor(
    private readonly store: Store<AppState>,
    private readonly deadlineService: DeadlineService,
  ) {}

  ngOnInit(): void {
    this.helper.addMany(
      this.store
        .select(InstructionDetailsSelectors.myInstruction)
        .subscribe((data) => {
          this.isLoadingMyInstruction = data.isLoadingMyInstruction;
          this.myInstruction = data.myInstruction;
        }),

      this.store
        .select(InstructionDetailsSelectors.myInstructionConfirmation)
        .subscribe((data) => {
          this.myInstructionConfirmation = data.myInstructionConfirmation;
          this.isLoadingMyInstructionConfirmation =
            data.isLoadingMyInstructionConfirmation;

          this.deadlineStatus = this.deadlineService.deadlineStatus(
            this.myInstructionConfirmation?.deadline,
          );
        }),
    );
  }

  ngOnDestroy(): void {
    this.helper.unsubscribeAll();
  }

  ngAfterViewInit(): void {}

  chapterSelected(chapter: Chapter) {
    this.store.dispatch(
      InstructionDetailsActions.selectChapter({
        chapter: chapter,
      }),
    );
  }
}
